module.exports = __webpack_public_path__ + "teqbahn-assets/media/3.34fa871c.pdf";